import { render, staticRenderFns } from "./BuyerReturn.vue?vue&type=template&id=46349e0a&"
import script from "./BuyerReturn.vue?vue&type=script&lang=js&"
export * from "./BuyerReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports